import 'jquery';

import '../../node_modules/font-awesome/scss/font-awesome';
import '../Styles/styles.scss';
import "../Styles/wcgloader.scss";

import './window';
import './storage.service';
import './models/common';
import './models/rememberMe.model';
import './models/authenticate.model';
import './models/password.model';

import Application from './application';

$(() => {
	var app = new Application();

	app.Initialize();
});



// WEBPACK FOOTER //
// ./Client/Scripts/index.ts